
import { mapState, mapActions } from 'vuex';

export default {
  name: 'AppForm',
  props: {
    objectId: { type: String, required: true },
    fields: {
      type: Array,
      required: true,
      validator: fields =>
        fields.length && fields.every(f => ['key', 'type'].every(k => f[k]))
    },
    focusFieldKey: { type: String, default: '' },
    variant: {
      type: String,
      default: 'default',
      validator: v => ['default', 'custom'].includes(v)
    }
  },
  computed: {
    ...mapState('form', ['formValues', 'fieldErrors'])
  },
  methods: {
    ...mapActions('form', ['setFieldValue', 'validateField']),
    submit() {
      this.$emit('submit');
    },
    fieldComponent(fieldType) {
      switch (fieldType) {
        case 'password':
          return 'AppPasswordInput';
        case 'select':
          return 'AppSelect';
        case 'text':
          return 'AppTextInput';
        case 'number':
          return 'AppNumberInput';
        default:
          throw `Undefined field type ${fieldType}`;
      }
    }
  }
};
